<template>
    <v-snackbar
        v-model="state.show"
        :color="state.color"
        :timeout="state.timeout"
        top
        right
    >
        <div class="d-flex align-center">
            <v-icon dark left>{{ icon }}</v-icon>
            <span>{{ state.text }}</span>
        </div>
        <template v-slot:action="{ attrs }">
            <v-btn icon dark v-bind="attrs" @click="state.show = false">
                <v-icon>mdi-close</v-icon>
            </v-btn>
        </template>
    </v-snackbar>
</template>

<script>
    import { notify } from '@/plugins/notify'

    export default {
        name: 'AppSnackbar',
        data() {
            return {
                state: notify.state
            }
        },
        computed: {
            icon() {
                return {
                    success: 'mdi-check-circle-outline',
                    error: 'mdi-alert-circle-outline'
                }[this.state.color] || 'mdi-information-outline'
            }
        }
    }
</script>
